import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {IQuestionnaire} from "../../storage/interfaces/questionnaire.interface";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {IApiResponse} from "../../storage/interfaces/api.interface";

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private _http: HttpClient) {
  }

  getQuestionnairesByRRU(rru: number): Observable<IApiResponse<IQuestionnaire<string>[]>> {
    return this._http.get<IApiResponse<IQuestionnaire<string>[]>>(encodeURI(`${URL}references/rru/${rru}/questionnaires`));
  }
}